import currency from "@/functions/currency";
import { format } from "date-fns";
import {
  Area,
  AreaChart,
  Bar,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

export default function TrendKomisi({ datas = [], date = {} }) {
  const renderTooltipContent = (o) => {
    const { payload } = o;
    const total = payload?.reduce((result, entry) => result + entry.value, 0);

    return (
      <div className='bg-shadesGON-50 p-2'>
        <p className='text-sm text-primaryGON-400'>{currency(total)}</p>
      </div>
    );
  };

  return (
    <div
      className=' bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8
      flex flex-col gap-6
      overflow-hidden overflow-x-scroll
      '>
      <div className='flex flex-col gap-2'>
        <p className='subheading-semiBold text-greyscaleGON-700'>
          Trend Komisi
        </p>
        <p className='p2-regular sm:p1-regular text-greyscaleGON-400'>
          Trend komisi{" "}
          {!date?.date_numeric
            ? !date?.date_until
              ? format(!date?.date_from ? new Date() : date?.date_from, "PPP")
              : `${format(date?.date_from, "PPP")} - ${format(
                  date?.date_until,
                  "PPP"
                )}`
            : `dalam ${date?.date_numeric} hari terakhir`}
        </p>
      </div>
      <ResponsiveContainer
        width='100%'
        height={250}>
        <AreaChart
          width={"100%"}
          height={250}
          data={datas ?? []}
          margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 0,
          }}>
          <defs>
            <linearGradient
              id='colorUv'
              x1='0'
              y1='0'
              x2='0'
              y2='1'>
              <stop
                offset='15%'
                stopColor='#CAAAF8'
                stopOpacity={0.8}
              />
              <stop
                offset='100%'
                stopColor='#E7D9FC'
                stopOpacity={0}
              />
            </linearGradient>
          </defs>
          <XAxis
            dataKey='date'
            stroke='#AB75FF'
            fontSize={12}
          />
          <YAxis
            stroke='#AB75FF'
            stopColor='#AB75FF'
            tickFormatter={(val) => currency(val)}
            fontSize={12}
          />
          <Tooltip
            content={renderTooltipContent}
            separator='none'
          />
          <Area
            type='monotone'
            dataKey='total_price_comsision_db'
            stroke='#5A25B0'
            fillOpacity={1}
            fill='url(#colorUv)'
          />
          <Bar
            dataKey='total_price_comsision_db'
            barSize={20}
            fill='#413ea0'
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
